export function isAnimationEnabled(): boolean {
	const queryStringParameters = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
	return queryStringParameters.filter(x => x === 'babbage=true').length === 0;
}
